<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"

    v-slot="{listeners, attrs, value, vuelidateIns}"

    v-model="colorBase"

    :class="{opened}"
  >
    <div class="color-picker-wrapper">
      <div
        class="preview"
        :style="{backgroundColor}"
      ></div>
      
      <input
        class="form-control"

        :value="value"
        :class="vuelidateIns && 'border-danger'"
        placeholder="#A8A8A8FF"

        @focus="focus"
  
        v-bind="attrs"
        v-on="listeners"
      >
      <div v-if="opened" class="color-picker">
        <ColorPicker
          v-model="colorBase"

          :inline="true"
        />
      </div>
    </div>
  </BaseFieldWrapper>
</template>

<script>

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"
import ColorPicker from "primevue/colorpicker"

const defaultColor = "A8A8A8FF"

export default {
  components: {
    BaseFieldWrapper,
    ColorPicker,
  },
  props: {
    ...props,

    value: String,
  },
  data() {
    return {
      opened: false,
      alreadyFocused: false,
      colorBase: this.value ? this.value.replace(/#/, "") : "",
    }
  },
  methods: {
    findDropdownPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      if (!found) this.opened = false
    },
    focus() {
      const currentColor = this.colorBase
      this.opened = true
      currentColor && this.$nextTick(() => this.colorBase = currentColor)
      
      if (this.alreadyFocused) return;
      this.alreadyFocused = true

      this.colorBase = defaultColor
    },
  },
  computed: {
    backgroundColor() {
      return this.color || ("#" + defaultColor)
    },
    color() {
      return "#" + this.colorBase
    },
  },
  watch: {
    value(val) {
      this.colorBase = val.replace(/#/, "")
    },
    color(val) {
      this.$emit("input", val[0] === "#" ? val : ("#" + val))
    },
    
    opened(val) {
      if (val) {
        window.addEventListener("click", this.findDropdownPath)
      } else {
        window.removeEventListener("click", this.findDropdownPath)
      }
    },
  },
}

</script>

<style>

.p-colorpicker-hue {
  background: transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAACWCAIAAAC3uvTNAAAA7ElEQVRYw+2YUQqDQAxEh9GWuqV6Be9/JT88RN0VRUuv0ElBwhKY3yF5m90kLKd+mF/975r6geNyjm9Fy0kgqTJ6nqoIdGKczjmPJU5tZxA8wWPL7YOHKhZAlcmTAVVcxSCrMbfgqY/H6JEOoASPe56tgSrqLR7U2zWojwWjJ3jq47HEiZoGTwJxP1RRXw8y9RZfCMhbhTHOVTxXnUFtPJ5rGjzu35y2KfKGQxWT2K4TQL1d2zz6KAH1kRU8wfOXx+37qY3Hct+aDaqot2u7R/wMuDS3qnj0z0HqK4X/+kRNHdfUwFP2Nisqe/sFuUZiVjC9HCUAAAAASUVORK5CYII=) no-repeat 0 0 !important;
}

.p-colorpicker-color {
  background: transparent url(https://www.primefaces.org/primevue/img/color.c7a33805.png) no-repeat 0 0 !important;
}

.p-colorpicker-color-handle {
  display: none;
}

</style>

<style scoped>

.color-picker-wrapper {
  position: relative;
  z-index: 0;
}

.opened {
  z-index: 10;
}

.preview {
  position: absolute;
  left: 3px;
  width: 6px;
  height: 90%;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 1px;
}

.color-picker {
  position: absolute;
  left: 0;
  top: 100%;

  box-shadow: 1px 2px 3px rgb(0 0 0 / 13%);
  background-color: white;
}

input {
  padding-left: 18px;
  border: 1px solid #E3E3E3 !important;
}

</style>
